'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Caption = exports.Subtitle = exports.Title = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.makeHeader = exports.Header = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  font-size: ', ';\n  font-weight: ', ';\n  color: ', ';\n  line-height: 1.2;\n  margin: 0.2em 0;\n'], ['\n  font-size: ', ';\n  font-weight: ', ';\n  color: ', ';\n  line-height: 1.2;\n  margin: 0.2em 0;\n']),
    _templateObject2 = _taggedTemplateLiteral([''], ['']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// Don't style anything after h3
var maxHeading = 3;

var calcFontSize = function calcFontSize(props) {
  var scale = props.theme.slide.fontScale || 1.0;
  var level = props.level || 0;

  // [0..maxHeading]
  var pow = Math.min(Math.max(0, maxHeading - level + 1), maxHeading);

  var size = Math.pow(scale, pow);
  return size + 'em';
};

var Header = exports.Header = _styledComponents2.default.h1(_templateObject, calcFontSize, function (props) {
  return props.weight;
}, function (props) {
  return props.color;
});

var makeHeader = exports.makeHeader = function makeHeader(tag, level, weight) {
  return Header.withComponent(tag).extend.attrs({ level: level, weight: weight })(_templateObject2);
};

// Header components
var H1 = exports.H1 = makeHeader('h1', 1, 'bold');
var H2 = exports.H2 = makeHeader('h2', 2, 'normal');
var H3 = exports.H3 = makeHeader('h3', 3, 'normal');
var H4 = exports.H4 = makeHeader('h4', 4, 'normal');

// Friendly aliases
var Title = exports.Title = H1;
var Subtitle = exports.Subtitle = H2;
var Caption = exports.Caption = H3;